import { useState } from "react";
import { Box, Typography, TextField } from "@mui/material";
import { Box as BoxIcon } from "@mynaui/icons-react";
import WorkOrderCard from "../components/WorkOrderCard";
import { useZone } from "../../../shared/context/ZoneContext";
import { getDashboardDataByZone } from "../data/dashboardMockData";

export default function WorkOrdersPage() {
  const { selectedZone } = useZone();
  const { workOrders } = getDashboardDataByZone(selectedZone);
  const [searchQuery, setSearchQuery] = useState("");

  const filteredOrders = workOrders.filter(
    (order) =>
      order.id.toLowerCase().includes(searchQuery.toLowerCase()) ||
      order.title.toLowerCase().includes(searchQuery.toLowerCase()),
  );

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100%",
      }}
    >
      <Box
        sx={{
          px: { xs: 2, sm: 3, md: 4 },
          py: { xs: 2, sm: 2.5, md: 3, lg: 4 },
        }}
      >
        {/* Page container */}
        <Box
          sx={{
            background: "#FFFFFF",
            border: "1px solid #E2E8F0",
            borderRadius: "12px",
            padding: "24px",
            display: "flex",
            flexDirection: "column",
            gap: "24px",
          }}
        >
          {/* Header: Title + Search */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 2,
              flexWrap: "wrap",
            }}
          >
            {/* Left: Icon + Title */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
              }}
            >
              <BoxIcon size={24} />
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: "18px",
                  lineHeight: "28px",
                  color: "#020618",
                }}
              >
                Work Orders
              </Typography>
            </Box>

            {/* Right: Search */}
            <TextField
              placeholder="Search"
              size="small"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              slotProps={{
                input: {},
              }}
              sx={{
                width: { xs: "100%", sm: "280px", md: "488px" },
                "& .MuiOutlinedInput-root": {
                  borderRadius: "8px",
                  fontSize: "14px",
                  "& fieldset": {
                    borderColor: "#E2E8F0",
                  },
                  "&:hover fieldset": {
                    borderColor: "#CBD5E1",
                  },
                },
              }}
            />
          </Box>

          {/* Cards Grid */}
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: "20px",
            }}
          >
            {filteredOrders.map((order, index) => (
              <Box
                key={`${order.id}-${index}`}
                sx={{
                  flex: {
                    xs: "1 1 100%",
                    md: "1 1 calc(50% - 10px)",
                  },
                  maxWidth: {
                    xs: "100%",
                    md: "calc(50% - 10px)",
                  },
                }}
              >
                <WorkOrderCard workOrder={order} />
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
